// actionTypes.js
export const SET_VALUE_ModelePmes = "SET_VALUE_ModelePmes";
export const SET_TYPE_ModelePmes = "SET_TYPE_ModelePmes";
export const SET_CURRENT_PAGE_ModelePmes = "SET_CURRENT_PAGE_ModelePmes";
export const SET_ORDER_ModelePmes = "SET_ORDER_ModelePmes";
export const SET_SORT_FIELD_ModelePmes = "SET_SORT_FIELD_ModelePmes";
export const SET_ACTIF_ModelePmes = "SET_ACTIF_ModelePmes";
export const SET_CATEGORIE_ModelePmes = "SET_CATEGORIE_ModelePmes";
